<section class="timeout BCcontainer gray-background text-center">
	<h1 class="alignment">Session Timeout.</h1>
    <p class="alignment">Your session was closed due to inactivity. Please re-login.</p>
</section>